export default {
    "multi": [
        {
            "description": "I'm not exactly sure what situation this is appropirate for, but the source for it ([VITAS - The 7th Element](https://www.youtube.com/watch?v=PWmfNeLs7fA)) is a true gem.\n",
            "message": "bloop_1_of_4,bloop_2_of_4\nbloop_3_of_4,bloop_4_of_4\n",
            "extension": "gif"
        },
        {
            "message": "conflicted_00,conflicted_01,conflicted_02\nconflicted_10,conflicted_11,conflicted_12\nconflicted_20,conflicted_21,conflicted_22\n",
            "extension": "gif"
        },
        {
            "description": "Steps:\n\n1. **Lie** down\n2. **Try** not to cry\n3. **Cry** a lot\n\nQuite often used in conjunction with :feels:.\n",
            "message": "cry_1,cry_2,cry_3\n",
            "extension": "png"
        },
        {
            "message": "excellent_choice_n00,excellent_choice_n01,excellent_choice_n02,excellent_choice_n03\nexcellent_choice_n10,excellent_choice_n11,excellent_choice_n12,excellent_choice_n13\n",
            "extension": "gif"
        },
        {
            "description": "I'm pretty sure this was my first multi-emoji. I made sure to make the mid section tilable so that you can make very long long cats.\n",
            "message": "longcat1\nlongcat2\nlongcat3\n",
            "extension": "png"
        },
        {
            "description": "For when you think you're done with something but you're probably not.\n",
            "message": "mission_accomplished_1,mission_accomplished_2,mission_accomplished_3,mission_accomplished_4,mission_accomplished_5\n",
            "extension": "png"
        },
        {
            "description": "For John Richmond.\n",
            "message": "pain-00,pain-01,pain-02\npain-10,pain-11,pain-12\npain-20,pain-21,pain-22\n",
            "extension": "png"
        },
        {
            "message": "terrific_00,terrific_01,terrific_02\nterrific_10,terrific_11,terrific_12\n",
            "extension": "gif"
        },
        {
            "description": "For when you, or anyone else mistypes upvote.\n",
            "message": "upboat-1,upboat-2\n",
            "extension": "png"
        },
        {
            "message": "waaat_1of9,waaat_2of9,waaat_3of9\nwaaat_4of9,waaat_5of9,waaat_6of9\nwaaat_7of9,waaat_8of9,waaat_9of9\n",
            "extension": "gif"
        },
        {
            "message": "yes_00,yes_01,yes_02\nyes_10,yes_11,yes_12\nyes_20,yes_21,yes_22\n",
            "extension": "gif"
        }
    ],
    "single": [
        {
            "message": "airhorn",
            "extension": "png",
            "description": "[www.instantrapairhorn.com](http://www.instantrapairhorn.com/)\n"
        },
        {
            "message": "beans",
            "extension": "png",
            "description": "Often used in conjunction with the 🆒 emoji.\n"
        },
        {
            "message": "beautiful",
            "extension": "gif"
        },
        {
            "message": "bg",
            "description": "For when it was not gg.\n",
            "extension": "png"
        },
        {
            "message": "busey",
            "extension": "png"
        },
        {
            "message": "chuckle",
            "extension": "gif"
        },
        {
            "message": "feel",
            "extension": "png"
        },
        {
            "message": "flaky",
            "description": "One way to make flaky tests more fun is to have an emoji for them...\n",
            "extension": "png"
        },
        {
            "message": "flaky2",
            "description": "... or two.\n",
            "extension": "png"
        },
        {
            "message": "http_202",
            "description": "\"HTTP 202 ACCEPTED: The request has been accepted for processing, but the processing has not been completed.\"\n\nUseful for when someone asks you something and you need a minute, or if you need to look something up before getting back to them.\n",
            "extension": "png"
        },
        {
            "message": "kick",
            "extension": "png"
        },
        {
            "message": "lgtm",
            "extension": "png"
        },
        {
            "message": "lmao",
            "extension": "png"
        },
        {
            "message": "maybedoit",
            "extension": "png"
        },
        {
            "message": "nbsp",
            "description": "A necessity for drawing with emoji.\n",
            "extension": "png"
        },
        {
            "message": "prettygood",
            "extension": "png"
        },
        {
            "message": "yas",
            "description": "[YAS VELOCIRAPTOR YAAS](https://www.youtube.com/watch?v=yHEs5k7nGZc)\n",
            "extension": "png"
        }
    ]
};



// WEBPACK FOOTER //
// ./src/data/emoji.js